/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  SettingsService,
  ISettingsMethods,
  IMasqueraderListsMethods,
  MasqueraderListsService,
} from "./components";

export type CostumePageAgent = IStaticPageContentMethods &
  IMasqueraderListsMethods &
  ISettingsMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new MasqueraderListsService(),
    new SettingsService(),
  ];
};

export const getAgent = () => {
  return createAgent<CostumePageAgent>({
    plugins: getPlugins(),
  });
};
